import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';


import { WindowModalComponent } from './window-modal.component';
import { Util } from '../utils/utils.module';

@Component({
  selector: 'edx-window-modal-form-login',
  styleUrls: ['window-modal.component.scss', 'window-modal-form-login.component.scss'],
  template: `
    @if (showLogin()) {
      <div class="window-modal-popup-login  window-modal-popup  window-modal" [ngClass]="{mobile: ui!=0&&ui!=1, oai: isAddin}">
        <edx-form-login></edx-form-login>
      </div>
    }
    @if (runSpinner()) {
      <edx-spinner ></edx-spinner>
    }
    `,
  standalone: false
})

export class WindowModalFormLoginComponent extends WindowModalComponent implements OnInit {
  constructor(protected location: Location, protected router: Router, protected route: ActivatedRoute) {
    super(location, router, route);
  }

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit() {
    //do not call super
    //super.ngOnInit();
  }

  public runSpinner(): boolean {
    return !Util.Device.bUseWebLogin && Util.RestAPI.nConnectErrors <= 3;
  }

  public showLogin(): boolean {
    return Util.Device.bUseWebLogin;
  }
}
